import React, { useEffect, useState } from "react";
import authorisationsHelper from "../../../../../API/Authorisations/authorisationsHelper";
import useWorkspaces from "../../../../../Hooks/useWorkspaces";
import FunctionHiringTemplateView from "./FunctionHiringTemplateView";

const FunctionHiringTemplate = ({ tool, onComplete, onCancel }) => {
  const [availableAuthorisations, setAvailableAuthorisations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getActiveWorkspace } = useWorkspaces();

  useEffect(() => {
    fetchAuthorisations();
  }, [getActiveWorkspace()?.id]);

  const fetchAuthorisations = async () => {
    try {
      setIsLoading(true);
      const authorisations = await authorisationsHelper.getAuthorisations(
        getActiveWorkspace()?.id
      );
      const _auth =
        authorisations?.data?.authorisationsByWorkspace?.items?.filter(
          (u) => u?._deleted != true
        ) || [];

      setAvailableAuthorisations(_auth);
    } catch (error) {
      console.error("Error fetching authorisations:", error);
      setAvailableAuthorisations([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (data) => {
    const selectedAuth = availableAuthorisations?.find(
      (a) => a?.id === data?.authorisationID
    );
    onComplete({
      ...data,
      authorisationType: selectedAuth?.type,
    });
  };

  return (
    <FunctionHiringTemplateView
      tool={tool}
      availableAuthorisations={availableAuthorisations}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  );
};

export default FunctionHiringTemplate;
